@if (attachments?.length) {
  <div class="file-list">
    @for (file of attachments; track file.id) {
      <div class="file-item">
        <div class="file-type-badge" [ngClass]="getFileTypeClass(file.contentType)">
          <mat-icon>{{ getFileIcon(file.contentType) }}</mat-icon>
        </div>
        <div class="file-info">
          <span class="file-name">{{ file.fileName }}</span>
          <span class="file-meta">{{ file.contentType | fileType }}@if (file.fileSize) {
            <span class="meta-sep">·</span>
            }{{ file.fileSize | fileSize }}@if (file.uploadedAt) {
            <span class="meta-sep">·</span>
            <span>{{ file.uploadedAt | date: 'dd.MM.yyyy' }}</span>
          }</span>
        </div>
        <div class="file-actions">
          @if (canView(file)) {
            <button type="button" mat-icon-button class="btn-tertiary" (click)="onView(file)"
                    [attr.title]="'ANNOUNCEMENTS.DETAILS.ATTACHMENT_VIEW' | translate"
                    [attr.aria-label]="('ANNOUNCEMENTS.DETAILS.ATTACHMENT_VIEW' | translate) + ': ' + file.fileName">
              <mat-icon>visibility</mat-icon>
            </button>
          }
          <button type="button" mat-icon-button class="btn-tertiary" (click)="onDownload(file)"
                  [attr.title]="'ANNOUNCEMENTS.DETAILS.ATTACHMENT_DOWNLOAD' | translate"
                  [attr.aria-label]="('ANNOUNCEMENTS.DETAILS.ATTACHMENT_DOWNLOAD' | translate) + ': ' + file.fileName">
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
}
